/** Takes in date, month, year as whole numbers and returns the string of formatted date (date-month-year) */
export const monthFormat = (
  date: number,
  month: number,
  year: number
): string => `${date}-${month}-${year}`;
